"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.App = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _PageComponent = _interopRequireDefault(require("./PageComponent"));
var _uxcore = require("@ux/uxcore2");
var _storeProvider = require("./../util/storeProvider");
var _EnvironmentDataComponent = _interopRequireDefault(require("./EnvironmentDataComponent"));
var _querystring = _interopRequireDefault(require("querystring"));
var _AppStyles = require("./App.styles.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class App extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.continueButtonDiv = /*#__PURE__*/_react.default.createRef();
    this.containerDiv = /*#__PURE__*/_react.default.createRef();
    this.handleContinue = this.handleContinue.bind(this);
  }
  handleContinue() {
    this.context.store.handleContinueClick();
  }
  render() {
    const {
      initial,
      redirect: redirectOnInitialError,
      error,
      showNoThanksFreeOfferButton = false,
      showOrderSummary = true,
      content = {},
      currentPage
    } = this.props;
    const {
      postComplete
    } = this.context;
    const disabled = !(initial || postComplete);
    const {
      apiError,
      continueToCart = '',
      loadingMessage,
      scrollToCart = ''
    } = content;
    const {
      content: pageContent
    } = this.context.store.getPageVariable();
    const {
      content: propContent
    } = this.context.store.initProps;
    const {
      redirectMessage = ''
    } = pageContent;
    const messages = propContent && Object.keys(propContent).length > 0 ? propContent : pageContent;
    const constants = this.context.store.getState('constants');
    const searchParams = _querystring.default.parse(global.location && global.location.search && global.location.search.substring && global.location.search.substring(1));
    let environmentData = null;
    const {
      configdevmode
    } = searchParams;
    if (constants.isInternal && configdevmode) {
      environmentData = /*#__PURE__*/_react.default.createElement(_EnvironmentDataComponent.default, {
        containerDiv: this.containerDiv
      });
    }
    const {
      apiError: pageContentApiError = '',
      loadingMessage: pageContentLoadingMessage = ''
    } = messages;
    if (redirectOnInitialError) {
      const redirectDiv = /*#__PURE__*/_react.default.createElement(_uxcore.Alert, {
        dismissible: false
      }, redirectMessage);
      return /*#__PURE__*/_react.default.createElement(_AppStyles.StyledContainer, {
        className: "redirect",
        postComplete: postComplete
      }, redirectDiv, environmentData);
    }
    if (initial === null) {
      //eslint-disable-line
      return /*#__PURE__*/_react.default.createElement(_AppStyles.StyledContainer, {
        postComplete: postComplete
      }, /*#__PURE__*/_react.default.createElement(_AppStyles.LoadingHeadline, {
        className: "loading-headline"
      }, /*#__PURE__*/_react.default.createElement(_uxcore.Spinner, {
        inline: true,
        size: "md"
      }), " ", loadingMessage || pageContentLoadingMessage), environmentData);
    }
    const alertDiv = /*#__PURE__*/_react.default.createElement(_uxcore.Alert, {
      dismissible: false
    }, apiError || pageContentApiError);
    if (initial && error) {
      return /*#__PURE__*/_react.default.createElement(_AppStyles.StyledContainer, {
        postComplete: postComplete,
        className: "error"
      }, alertDiv, environmentData);
    }
    const colClass = showOrderSummary ? 'col-sm-12 col-xl-8' : 'col-sm-12';

    // continueButtonDiv ref has to be attached before sending it as a prop to StickyComponent
    const continueBtn = /*#__PURE__*/_react.default.createElement("div", {
      className: "row text-right",
      ref: this.continueButtonDiv
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: colClass
    }, showNoThanksFreeOfferButton ? null : /*#__PURE__*/_react.default.createElement(_uxcore.Button, {
      className: "continue-button",
      "data-eid": this.context.store.getEid('continue', 'submit', 'click'),
      design: "primary",
      disabled: disabled,
      onClick: this.handleContinue,
      text: continueToCart
    })));
    return /*#__PURE__*/_react.default.createElement(_AppStyles.StyledContainer, {
      postComplete: postComplete,
      forwardref: this.containerDiv
    }, error && alertDiv, /*#__PURE__*/_react.default.createElement(_PageComponent.default, {
      includeState: [{
        path: 'pages',
        propKey: 'pages'
      }],
      showOrderSummary: showOrderSummary,
      continueButtonDiv: this.continueButtonDiv,
      colClass: colClass,
      scrollToCartText: scrollToCart,
      currentPage: currentPage,
      continueButton: continueBtn
    }), environmentData);
  }
}
exports.App = App;
App.propTypes = {
  initial: _propTypes.default.bool,
  redirect: _propTypes.default.bool,
  error: _propTypes.default.bool,
  postComplete: _propTypes.default.bool,
  showNoThanksFreeOfferButton: _propTypes.default.bool,
  showOrderSummary: _propTypes.default.bool,
  content: _propTypes.default.shape({
    apiError: _propTypes.default.string,
    loadingMessage: _propTypes.default.string,
    continueToCart: _propTypes.default.string,
    total: _propTypes.default.string,
    included: _propTypes.default.string,
    legalTaxText: _propTypes.default.string,
    legalTermLengthText: _propTypes.default.string,
    scrollToCart: _propTypes.default.string,
    orderSummary: _propTypes.default.string,
    perMonth: _propTypes.default.string,
    perYear: _propTypes.default.string,
    perSite: _propTypes.default.string,
    per: _propTypes.default.string,
    monthPlural: _propTypes.default.string,
    yearPlural: _propTypes.default.string,
    noThanksOnFreeOffer: _propTypes.default.string,
    monthSingular: _propTypes.default.string,
    yearSingular: _propTypes.default.string,
    renewsAt: _propTypes.default.string,
    englishLangProductMesg: _propTypes.default.string,
    saleDiscount: _propTypes.default.string
  }),
  currentPage: _propTypes.default.number
};
var _default = exports.default = (0, _storeProvider.provideContext)(App);